import { Button } from 'antd'
import styled from 'styled-components'

export const MyBtn = styled(Button)<{ $dark?: boolean }>`
  padding: 7px 16px;
  border-width: 2px;
  height: 40px;
  border-radius: 90px;
  box-shadow: none;
  &.ant-btn-lg {
    font-size: 16px;
    height: 48px;
  }
  &.ant-btn-sm {
    font-size: 12px;
    height: 24px;
    padding: 0 12px;
    border-width: 1px;
  }
  &.ant-btn-default {
    border-color: ${props =>
      props.$dark ? props.theme.dark3 : props.theme.light1};
    background: none;
    color: ${props => (props.$dark ? props.theme.dark4 : props.theme.dark2)};
    &:hover {
      background: none;
      color: ${props =>
        props.$dark ? props.theme.dark5 : props.theme.primaryColor};
      border-color: ${props =>
        props.$dark ? props.theme.dark5 : props.theme.primaryColor};
    }
    &[disabled] {
      background: none;
      border-color: ${props => props.theme.light1};
      color: ${props => props.theme.dark4};
    }
  }
  &.ant-btn-primary {
    border-color: transparent;
    background: ${props => props.theme.primary};
    color: ${props => props.theme['neutral-800']};
    &:hover {
      background: ${props => props.theme['primary-300']};
    }
    &:active {
      background: ${props => props.theme['primary-700']};
    }
    &[disabled] {
      border-color: transparent;
      background: ${props => props.theme['primary-100']};
      color: ${props => props.theme['neutral-800']};
      &:hover {
        background: ${props => props.theme['primary-100']};
      }
      &:active {
        background: ${props => props.theme['primary-100']};
      }
    }
  }
  &.ant-btn-circle {
    height: 32px;
    border-radius: 50%;
    padding: 0;
  }
`
